import type { Auth } from 'firebase/auth';

export type OptionalTestAuthSignIn = Promise<void> | null;

function canStartBrowserTestAuthSignIn() {
  return (
    process.env.EXPO_PUBLIC_ENV_NAME === 'dev' &&
    typeof window !== 'undefined' &&
    window.navigator.webdriver
  );
}

export default function startOptionalTestAuthSignIn(
  auth: Auth,
): OptionalTestAuthSignIn {
  if (!canStartBrowserTestAuthSignIn()) {
    return null;
  }

  return import('@/testing/playwrightAuth')
    .then(({ signInPlaywrightUser }) => signInPlaywrightUser(auth))
    .catch((error: unknown) => {
      // biome-ignore lint/suspicious/noConsole: Test auth failures should be visible in test output.
      console.error('Test auth error: ', error);
    });
}
